import { SelectableSettings } from '@progress/kendo-angular-grid';

export class NotificationGridConfig {
  static readonly SOURCE_TYPE = 'AlertSubscription';
  static readonly TABS = [
    {
      title: 'My Notifications',
      id: 0
    },
    {
      title: 'Current Notifications',
      id: 1
    },
    {
      title: 'All Notifications',
      id: 2
    }
  ];
  static readonly SELECTABLE_SETTINGS = <SelectableSettings> {
    enabled: true,
    checkboxOnly: true,
    mode: 'multiple'
  };
}
